/**
 * Procedure Categories and Procedures for M.Ch. in Urology students
 * Extracted with strict evidence from official NMC PDF (Page 7, 14-15, 29-32: "Psychomotor Domain - Perform independently or under supervision")
 */
export const UROLOGY_PROCEDURES = {
  "Endourology, Lithotripsy & Image-Guided Urological Procedures": [
    "Diagnostic & Operative Cystoscopy, Ureteral Catheterization & Double J (DJ) Stenting / Removal",
    "Rigid & Flexible Ureterorenoscopy (URS / RIRS) with Laser Lithotripsy",
    "Percutaneous Nephrolithotomy (PCNL) & Percutaneous Nephrostomy (PCN - USG/Fluoroscopy Guided)",
    "Transurethral Resection of Prostate (TURP / HOLEP) & Transurethral Incision of Prostate (TUIP / BNI)",
    "Transurethral Resection of Bladder Tumour (TURBT) & Cystolithotripsy / Cystolitholapaxy",
    "TRUS-Guided Prostate Biopsy & USG-Guided Renal Mass / Transplant Biopsy",
    "Extracorporeal Shock Wave Lithotripsy (ESWL) for Kidney & Ureteral Calculi",
  ],
  "Reconstructive, Laparoscopic & Pediatric Urological Surgeries": [
    "Open, Laparoscopic & Robotic Pyeloplasty for PUJ Obstruction",
    "Ureteric Reimplantation (Ureteroneocystostomy), Boari Flap & Psoas Hitch Ureteral Reconstruction",
    "Urethroplasty for Urethral Strictures (Anastomotic & Buccal Mucosa Graft / BMG Urethroplasty)",
    "Augmentation Enterocystoplasty & Urinary Diversion (Ileal Conduit / Continent Neobladder)",
    "Orchidopexy for Cryptorchidism / Undescended Testis & Torsion Testis Exploration / Orchidectomy",
    "Hypospadias Repair, Meatoplasty, Circumcision & Dorsal Slit",
    "Urodynamic Studies (Uroflowmetry, Filling Cystometry, Pressure-Flow Studies)",
  ],
  "Uro-Oncological, Transplant & Major Ablative Surgeries": [
    "Simple & Radical Nephrectomy (Open, Laparoscopic, Robotic) & Nephron-Sparing Partial Nephrectomy",
    "Radical Nephroureterectomy with Bladder Cuff Excision",
    "Radical Cystectomy with Pelvic Lymph Node Dissection & Urinary Diversion",
    "Radical & Open Simple Prostatectomy",
    "Partial & Total Penectomy with Ilioinguinal Lymph Node Dissection",
    "Live Donor Nephrectomy & Renal Transplantation",
    "Arteriovenous (AV) Fistula Creation for Hemodialysis Access & Varicocelectomy",
  ],
};

export const UROLOGY_CATEGORIES = Object.keys(UROLOGY_PROCEDURES);

export const isMChInUrologyDept = (department) => {
  if (!department) {
    try {
      const u = JSON.parse(
        localStorage.getItem("userData") || localStorage.getItem("user") || "{}"
      );
      department = u.department || (u.departments && u.departments[0]);
    } catch (e) {}
  }
  if (!department) return false;
  const d = String(department).toLowerCase();
  return (d.includes("urology") || d.includes("uro-oncology")) && !d.includes("neurology");
};
